import { getItems } from 'common/api/politicalDivisions';

import {
    FETCH_POLITICAL_DIVISIONS1,
    FETCH_POLITICAL_DIVISIONS1_FAILURE,
    FETCH_POLITICAL_DIVISIONS1_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default ({ country } = {}) =>
    (dispatch) => {
        dispatch(actions[FETCH_POLITICAL_DIVISIONS1]());

        getItems({ country })
            .then((response) =>
                dispatch(
                    actions[FETCH_POLITICAL_DIVISIONS1_SUCCESS](
                        response.data.data,
                    ),
                ),
            )
            .catch((error) =>
                dispatch(
                    actions[FETCH_POLITICAL_DIVISIONS1_FAILURE](
                        error?.response?.data?.errors,
                    ),
                ),
            );
    };
